import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { OrderLifetimeAction } from '../orderLifetime.action';
import { OrderLifetimeTranslator } from '../orderLifetime.translator';

type IDependencies = IClientApiDependencySegment;

export const loadOrderLifetimeEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(OrderLifetimeAction.loadList.started),
  mergeMap(() => {
    return dependencies.api.getOrderLifetimeProfileList().pipe(
      mergeMap((response) => {
        return [
          OrderLifetimeAction.loadList.done({
            result: {
              data: (response.profiles ?? []).map(OrderLifetimeTranslator.fromApi),
              defaultData: OrderLifetimeTranslator.defaultFromApi(response.default),
            },
          }),
        ];
      }),
      catchApiError((error) => {
        return [
          OrderLifetimeAction.loadList.failed({ error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
